import malaAtencion from '../assets/Beneficios-Mejora la experiencia de tus clientes.png'; // Adjust the path as necessary
import faltaPersonal from '../assets/Beneficios-Equipo capacitado con respuestas 247 4. Tiempo de respuesta eficaz.png'; // Adjust the path as necessary
import altaDemanda from '../assets/Beneficios-Mejores respuestas con tono amable.png'; // Adjust the path as necessary
import demasiadaInformacion from '../assets/Beneficios-Tiempo de respuesta eficaz.png'; // Adjust the path as necessary

function WhatItSolves() {
    return (
        <div className="what-it-solves">
            <div className="container py-3">
                <h2 className="section-title">Beneficios</h2>
                <div className="row text-center" style={{ padding: '3rem' }}>
                    <div className=" col-md-3 problem-icon">
                        <div className='beneficio'>
                            <img src={malaAtencion} alt="Mejora la experiencia de tus clientes" />
                        </div>

                        <p>Mejora la experiencia de tus clientes</p>
                    </div>
                    <div className="col-md-3 problem-icon">
                        <div className='beneficio'>
                            <img src={faltaPersonal} alt="Equipo capacitado con respuestas 24/7" />
                        </div>

                        <p>Equipo capacitado con respuestas 247 4.</p>
                    </div>
                    <div className="col-md-3 problem-icon">
                        <div className='beneficio'>
                            <img src={altaDemanda} alt="Mejores respuestas con tono amable" />
                        </div>

                        <p>Mejores respuestas con tono amable</p>
                    </div>
                    <div className="col-md-3 problem-icon">
                        <div className='beneficio'>
                            <img src={demasiadaInformacion} alt="Tiempo de respuesta eficaz" />
                        </div>

                        <p>Tiempo de respuesta eficaz</p>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default WhatItSolves;